import { useState } from "react";
import AITutorPanel from "@/components/AITutorPanel";
import { Sparkles, MessagesSquare } from "lucide-react";
import { Button } from "@/components/ui/button";
import BackButton from "@/components/BackButton";

export default function TutorPage() {
  const [open, setOpen] = useState(true);
  return (
    <div className="relative p-6 md:p-10 min-h-[80vh] bg-grid">
      <BackButton />
      <div className="mt-5 mb-8">
        <div className="mono text-[10px] uppercase tracking-widest text-muted-foreground">
          /ai tutor
        </div>
        <h1 className="font-display text-4xl font-extrabold tracking-tighter">
          AI Tutor
        </h1>
        <p className="mt-2 max-w-2xl text-sm text-muted-foreground">
          Switch between GPT-5.2, Claude Sonnet 4.5, and Gemini 3 Flash. Your conversation is persisted per session.
        </p>
      </div>
      <div className="border-2 border-foreground bg-background p-10 text-center">
        <Sparkles className="mx-auto h-8 w-8 text-primary" />
        <p className="mt-3 text-sm text-muted-foreground">
          Click below to open the AI Tutor side panel.
        </p>
        <Button
          onClick={() => setOpen(true)}
          className="mt-5 rounded-none bg-foreground text-background hard-shadow hover-lift"
          data-testid="open-tutor-page-btn"
        >
          <MessagesSquare className="mr-2 h-4 w-4" /> Open AI Tutor
        </Button>
      </div>
      <AITutorPanel open={open} onClose={() => setOpen(false)} courseContext="General Studies" />
    </div>
  );
}
